import { useMemo } from "react";
import { TABLE_BORDER_WIDTH } from "components/bootstrap/Table";
import useElementDimensions from "hooks/useElementDimensions";
import {
  BULK_SELECT_COLUMN_WIDTH,
  ACTIONS_COL_ID,
  ROW_EXPAND_COLUMN_WIDTH
} from "components/common/EntityDataTable/Constants";
import useColumnWidths from "components/common/EntityDataTable/hooks/useColumnWidths";
import useActionsColumnWidth from "components/common/EntityDataTable/hooks/useActionsColumnWidth";
const useElementWidths = ({
  columnRenderersByAttribute,
  columnSchemas,
  columnWidthPreferences,
  displayBulkSelectCol,
  displayRowExpandCol,
  entities,
  hasRowActions,
  headerMinWidths,
  scrollContainerRef,
  visibleColumns
}) => {
  const { colMinWidth: actionsColMinWidth, handleWidthChange: handleActionsWidthChange } = useActionsColumnWidth(entities, hasRowActions);
  const { width: scrollContainerWidth } = useElementDimensions(scrollContainerRef);
  const columnIds = useMemo(
    () => columnSchemas.filter(({ id }) => visibleColumns.includes(id)).map(({ id }) => id),
    [columnSchemas, visibleColumns]
  );
  const columnWidths = useColumnWidths({
    actionsColMinWidth,
    bulkSelectColWidth: displayBulkSelectCol ? BULK_SELECT_COLUMN_WIDTH : 0,
    rowExpandColWidth: displayRowExpandCol ? ROW_EXPAND_COLUMN_WIDTH : 0,
    columnIds,
    columnRenderersByAttribute,
    columnWidthPreferences,
    headerMinWidths,
    scrollContainerWidth
  });
  const tableMinWidth = Object.entries(columnWidths).reduce(
    (total, [colId, width]) => colId === ACTIONS_COL_ID ? total : total + width,
    TABLE_BORDER_WIDTH + actionsColMinWidth
  );
  return {
    handleActionsWidthChange,
    columnWidths,
    tableIsCompressed: actionsColMinWidth === columnWidths[ACTIONS_COL_ID],
    actionsColMinWidth,
    scrollContainerWidth,
    tableMinWidth
  };
};
export default useElementWidths;
